import Layout from "./Layout";

const PageLayout = ({ children, topBar = false, bottomBar = false, className = "", bottomPad = "pb-[75px]" }) => {
    return (
        <Layout className={className}>
            {topBar && <div className="sticky top-0 z-40">{topBar}</div>}
            <div className={`w-full ${bottomBar ? bottomPad : ""}`}>
                {children}
            </div>
            {bottomBar && (
                <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow-top">
                    {bottomBar}
                </div>
            )}
        </Layout>
    );
}

export default PageLayout;
